import NewsTipAdvancedView from './NewsTipAdvancedView'

export default NewsTipAdvancedView
